import axiosInstance, { ApiKeys, getApiUrl } from '@cp/utils/ApiHelper';
import { getFileDownload } from '@cp/utils/commonUtils';
import { toast } from '@primitives/Toast';
import { addClickstreamEvent } from '@cp/src/service/clickStreamEventService';
import { AGENT_AUTO_LOGOUT_CLICKSTREAM } from '@cp/pages/SelfServeStateResetter/constants';
import { GenericObject } from '@cp/src/types/CommonConstans';

type OnFormSubmitTypes = {
  form: GenericObject;
  onSuccessCb: () => void;
  onFailureCb: () => void;
  onFinalCb: () => void;
};

export const onFormSubmit = ({ form, onSuccessCb, onFailureCb, onFinalCb }: OnFormSubmitTypes) => {
  const stateResetterUrl = getApiUrl(ApiKeys.SELF_SERVE_STATE_RESETTER, {});
  axiosInstance
    .post(stateResetterUrl, form)
    .then(() => {
      onSuccessCb();
    })
    .catch(() => {
      onFailureCb();
    })
    .finally(() => {
      onFinalCb();
    });
};

export const onSampleFileDownload = () => {
  const sampleFileUrl = getApiUrl(ApiKeys.SELF_SERVE_STATE_RESETTER_SAMPLE_FILE_DOWNLOAD);
  axiosInstance.get(sampleFileUrl).then(res => {
    getFileDownload(res?.data?.data, true);
  });
};
